import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const TZ = "Asia/Kolkata";

const parts = (d) => ({
  day: d.toLocaleDateString("en-IN", { timeZone: TZ, day: "2-digit" }),
  mon: d.toLocaleDateString("en-IN", { timeZone: TZ, month: "short" }),
  full: d.toLocaleDateString("en-GB", { timeZone: TZ }).replace(/\//g, "/"),
  time: d.toLocaleTimeString("en-IN", {
    timeZone: TZ, hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
  }).toUpperCase(),
  short: d.toLocaleTimeString("en-IN", {
    timeZone: TZ, hour: "numeric", minute: "2-digit", hour12: true,
  }).toUpperCase(),
});

/** Always-visible live IST clock — rendered from the Asia/Kolkata timezone, never the device zone. */
export const IstClock = ({ compact = false }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const p = parts(now);

  if (compact) {
    return (
      <span
        data-testid="ist-clock-mobile"
        className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-indigo-50 px-2.5 py-1 text-[11px] font-semibold tnum text-indigo-800"
      >
        <Clock className="h-3 w-3" />
        {p.day} {p.mon} | {p.short} IST
      </span>
    );
  }

  return (
    <span
      data-testid="ist-clock"
      className="flex items-center gap-2 whitespace-nowrap rounded-full bg-indigo-50 px-3.5 py-1.5 text-xs font-semibold tnum text-indigo-800 ring-1 ring-indigo-100"
    >
      <Clock className="h-3.5 w-3.5" />
      {p.day} {p.mon} {now.toLocaleDateString("en-IN", { timeZone: TZ, year: "numeric" })} | {p.time} IST
    </span>
  );
};

export default IstClock;
